// src/app/shared/main-menu/main-menu.component.ts
import { CommonModule, AsyncPipe, JsonPipe } from '@angular/common';
import { Component,  ChangeDetectorRef, NgZone } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, } from '@angular/router';

import {
  IonChip,
  IonIcon,
  IonItem,
  IonItemDivider,
  IonLabel,
  IonList,

  IonMenuToggle,
} from '@ionic/angular/standalone';

import { combineLatest, map  } from 'rxjs';

import { addIcons } from 'ionicons';
import { albumsOutline, callOutline, chatbubblesOutline, clipboardOutline, homeOutline, key, libraryOutline, listOutline, lockClosed, logOutOutline, newspaperOutline, personOutline, pulseOutline, settingsOutline, walletOutline, } from 'ionicons/icons';

import { MenuItem } from '../../../models/menu-item.model';
import { AuthService, User } from '../../../services/auth/auth.service';
import { CountsService } from '../../../services/core/counts.service';
import { MenuService } from '../../../services/core/menu.service';


export interface MenuNode extends MenuItem {
  children?: MenuNode[];
}

export interface MenuNode extends MenuItem {
  children?: MenuNode[];
}

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss'],
  imports: [
    IonChip,
    IonIcon,
    IonItem,
    IonItemDivider,
    IonLabel,
    IonList,

    IonMenuToggle,


    CommonModule,
    AsyncPipe,
    RouterLink,
    RouterLinkActive,


  ],
})
export class MainMenuComponent {
  // You can tighten these keys once you know the exact stage strings.
  private readonly stageConfig: Record<string, MenuItem[]> = {
    assessor: [
      { id: 'home', label: 'Home', icon: 'home', url: 'home', order: 10 },
      { id: 'assessments', label: 'Assessments', icon: 'list', url: '/assessment-list', order: 20 },
      { id: 'missions', label: 'Missions', icon: 'albums-outline', url: '/missions', order: 25 },
      { id: 'pulse', label: 'Pulse', icon: 'pulse', url: '/pulse', order: 30 },
      { id: 'news', label: 'News', icon: 'newspaper', url: '/news', order: 40 },
      { id: 'resources', label: 'Resources', icon: 'library-outline', url: '/resources', order: 45 },
      { id: 'invoices', label: 'Invoices', icon: 'wallet', url: '/invoices', order: 50 },
      { id: 'forum', label: 'Forum', icon: 'chatbubbles-outline', url: '/forum', order: 55 },
      { id: 'account', label: 'Account', icon: 'person', url: '/account', order: 60 },
      { id: 'users', label: 'Impersonate', icon: 'lock-closed', url: '/users', order: 70 },
      { id: 'contact', label: 'Contact', icon: 'call', url: '/contact', order: 80 },
      { id: 'settings', label: 'Settings', icon: 'settings', url: '/settings', order: 90 },

    ],
    applying: [
      { id: 'home', label: 'Home', icon: 'home', url: '/', order: 10 },
      //{ id: 'account',  label: 'Account', icon: 'person', url: '/account', order: 20 },
      { id: 'settings', label: 'Settings', icon: 'settings', url: '/settings', order: 90 },

    ],
    applicant: [
      { id: 'home', label: 'Home', icon: 'home', url: '/', order: 10 },
      { id: 'account', label: 'Account', icon: 'person', url: '/account', order: 20 },
      { id: 'settings', label: 'Settings', icon: 'settings', url: '/settings', order: 90 },
    ],
    /*active: [
      { id: 'dashboard', label: 'Dashboard',  icon: 'home',    url: '/dashboard', order: 10 },
      { id: 'profile',   label: 'Profile',    icon: 'person',  url: '/profile',   order: 20 },
      { id: 'settings',  label: 'Settings',   icon: 'settings',url: '/settings',  order: 30 },
    ],
    suspended: [
      { id: 'status',    label: 'Account Status',   icon: 'warning', url: '/account/status', order: 10 },
      { id: 'contact',   label: 'Contact Support', icon: 'call',    url: '/support',        order: 20 },
    ],
    */
  };



   
  hasAlpha = false; // Whether user is in Alpha channel (will update on login/logout)






  // items$ = tree of nodes (top-level + children)
  readonly items$ = combineLatest([
    this.auth.user$,
    this.menuService.extraItems$,
  ]).pipe(
    map(([user, extra]) => {
      const base = this.getBaseItems(user);
      const all = [...base, ...extra];
      return this.buildTree(all);
    })
  );

  constructor(
    private auth: AuthService,
    private menuService: MenuService,
    private router: Router,
    public countsService: CountsService,
    private zone: NgZone,                 // Ensures change detection runs
   private cdr: ChangeDetectorRef,       // Forces UI refresh if needed
  ) {
    this.countsService.startPolling(3);
    addIcons({
      albumsOutline,
      clipboardOutline,
      chatbubblesOutline,
      'home': homeOutline,
      'list': listOutline,
      'pulse': pulseOutline,
      'newspaper': newspaperOutline,
      'call': callOutline,
      'wallet': walletOutline,
      libraryOutline,
      'person': personOutline,
      'lock-closed': lockClosed,
      'settings': settingsOutline,
      'sign-out': logOutOutline,
      key,
    });

    this.auth.user$.subscribe(async (user) => {
      const ok = user ? await this.auth.hasChannel('Alpha') : false; // Await the promise
      // console.log("🚀 ~ main-menu.component.ts:151 ~ MainMenuComponent ~ constructor ~ ok:", ok)


      // ✅ Run inside Angular so UI updates reliably
      this.zone.run(() => {
        this.hasAlpha = ok;
        this.cdr.markForCheck(); // Safe even if not OnPush
      });
    });
  }

  private getBaseItems(user: User | null): MenuItem[] {
    if (!user?.application_stage) return [];

    const stageKey = user.application_stage.toLowerCase();

    const items = this.stageConfig[stageKey] ?? [];

    // Filter based on permissions
    return items.filter(item => {
      if (item.id === 'users') {
        // only show "users" when user.permissions.userRead is true
        return !!user.permissions?.userRead;
      }
      return true;
    });

    //return this.stageConfig[stageKey] ?? [];
  }

  private buildTree(items: MenuItem[]): MenuNode[] {



    
    // 1. Sort all items by order
    const sorted = [...items].sort((a, b) => a.order - b.order);

    // 2. Index by id
    const byId = new Map<string, MenuNode>();
    sorted.forEach(item => {
      byId.set(item.id, { ...item, children: [] });
    });

    // 3. Build hierarchy
    const roots: MenuNode[] = [];
    byId.forEach(node => {
      if (node.parentId) {
        const parent = byId.get(node.parentId);
        if (parent) {
          parent.children!.push(node);
        } else {
          // parentId not found; treat as root fallback
          roots.push(node);
        }
      } else {
        roots.push(node);
      }
    });

    // 4. Sort children of each node
    roots.forEach(r => {
      if (r.children && r.children.length) {
        r.children.sort((a, b) => a.order - b.order);
      }
    });

    // 5. Sort roots by order too, just in case
    roots.sort((a, b) => a.order - b.order);
    return roots;
  }

  onClick(item: MenuItem): void {
    if (item.action) {
      item.action();
    } else if (item.url) {
      this.router.navigate([item.url]);
    }
  }
  onSignOut() {
    this.auth.logout( 'user_click' );
  }

}
